const isMac = /Macintosh/.test(navigator.userAgent);

if (isMac) {
  document.querySelectorAll('button.grid_view_button')?.forEach((Button) =>{
    Button?.classList.add("chrome-mac");
  })
}
//   function details_menuopen() {

//     if($(document).find('.hasdetails_menu').length){
//       if( $('.hasdetails_menu').attr('open')){}
//       else{
//         $('.hasdetails_menu').attr('open','');
//       }
//     }
//     if($(document).find('.hasdetails_submenu').length){
//       if( $('.hasdetails_submenu').attr('open')){}
//       else{
//         $('.hasdetails_submenu').attr('open','');
//       }
//     }
//   }
//   var interval = self.setInterval(function(){details_menuopen()},80);
$(document).ready(function(){
   $("button#grid_view_one-item").click(function(){ 
    $("button.grid_view_button").removeClass("active"); 
    $(this).addClass("active");
    if ($('div#ajaxinate-product_loop').hasClass("collection-page__list--3-column") || $('div#ajaxinate-product_loop').hasClass("collection-page__list--4-column")) {      
      $('.collection-page__list').removeClass("collection-page__list--4-column");
      $('.collection-page__list').removeClass("collection-page__list--3-column");
      $('.collection-page__list').addClass("collection-page__list--2-column");
    }
  });
  $("button#grid_view_two-item").click(function(){ 
    $(".grid_view_button").removeClass("active"); 
    $(this).addClass("active");
   if ($('div#ajaxinate-product_loop').hasClass("collection-page__list--2-column") || $('div#ajaxinate-product_loop').hasClass("collection-page__list--4-column")) {
     $('.collection-page__list').removeClass("collection-page__list--2-column");
      $('.collection-page__list').removeClass("collection-page__list--4-column");
      $('.collection-page__list').addClass("collection-page__list--3-column");
    }
  });
  $("button#grid_view_thr-item").click(function(){ 
    $("button.grid_view_button").removeClass("active"); 
    $(this).addClass("active");
    if ($('div#ajaxinate-product_loop').hasClass("collection-page__list--2-column") || $('div#ajaxinate-product_loop').hasClass("collection-page__list--3-column")) {
      $('.collection-page__list').removeClass("collection-page__list--2-column");
      $('.collection-page__list').removeClass("collection-page__list--3-column");
      $('.collection-page__list').addClass("collection-page__list--4-column");
    }
  });
//   if($(window).width() < 767) { 
    $("button#grid_medium_one-item").click(function(){ 
      $("button#grid_view_medium_two-item").removeClass("active"); 
      $(this).addClass("active");
      if ($('div#ajaxinate-product_loop').hasClass("collection-page__list--2-column-mobile")) {      
        $('div#ajaxinate-product_loop').removeClass("collection-page__list--2-column-mobile");
        $('div#ajaxinate-product_loop').addClass("collection-page__list--1-column-mobile");
      }
    });
    $("button#grid_view_medium_two-item").click(function(){ 
      $("button#grid_medium_one-item").removeClass("active"); 
      $(this).addClass("active");
      if ($('div#ajaxinate-product_loop').hasClass("collection-page__list--1-column-mobile")) {      
        $('div#ajaxinate-product_loop').removeClass("collection-page__list--1-column-mobile");
        $('div#ajaxinate-product_loop').addClass("collection-page__list--2-column-mobile");
      }
    });
//   }
   if($(window).width() < 575) {  
  $('.email-promotions').click();
    }
//   var product_pages = $('#ajaxinate-product_loop');
//   var product_url = product_pages.data('pagin_url');
//   //   $('.pagination_button').hide();
//   $('.pagination_button').click(function(e) {
//     e.preventDefault();
//     //     $('.pagination_button').hide();
//     //     $('.pagination_button').show();
//     //       function loadmoreProduct() {
//     //       e.preventDefault();
//     $.ajax({
//       url: product_url,
//       type:'GET',
//       dataType:'html',
//       success: function(next_page){ 
//         //         $('.ctt_loademore_icon').hide();
//         //           $('#ajax-content-2').html($(data).find('.collection-wrapper').html());
//         var new_product = $(next_page).find('#ajaxinate-product_loop');
//         var new_product_url = new_product.data('pagin_url');
//         //           alert(new_product_url);
//         if (new_product_url)
//           //           $('.pagination_button').show();
//           //         $('.pagination_button').attr('data-href',new_product_url);
//           //            $("button.ctt_loademore_btn").click(); 
//           product_url = new_product_url;
//         product_pages.append(new_product.html());
//       }
//     });
//     //       }
//   });
  
  
  
});